export const ENTERPRISE_ADMIN_COACH_MODE_ID = 'ENTERPRISE_ADMIN';

export const ENTERPRISE_ADMIN_COACH_REF = 'admin-coach';
